// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
enum ReferenceOptions {
    ALL = 0,
    HASREFERENCE = 1,
    HASNOREFERENCE = 2,
}
export default ReferenceOptions;
